import React from "react";

const PrivacyPolicy: React.FC = () => {
  return (
    <div
      style={{
        maxWidth: "860px",
        margin: "0 auto",
        padding: "60px 20px",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.7",
        color: "#111",
      }}
    >
      <h1>Privacy Policy</h1>
      <p style={{ color: "#666" }}>Last updated: April 14, 2026</p>

      <p>
        Intrex (“we,” “our,” or “us”) values your privacy. This Privacy Policy
        explains how we collect, use, and protect information when merchants use
        our app and related services.
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li>Store information (Shopify store data)</li>
        <li>Order and shipping information</li>
        <li>Customer shipping details</li>
        <li>Technical usage data</li>
      </ul>

      <h2>2. How We Use Information</h2>
      <ul>
        <li>Provide shipping rates and logistics</li>
        <li>Process orders</li>
        <li>Improve the app</li>
        <li>Provide support</li>
      </ul>

      <h2>3. Data Sharing</h2>
      <p>
        We do not sell personal data. Information is only shared with logistics
        partners (such as carriers) and infrastructure providers when necessary.
      </p>

      <h2>4. Data Retention</h2>
      <p>
        Data is retained only as long as necessary to provide our services and
        comply with legal obligations.
      </p>

      <h2>5. Security</h2>
      <p>
        We apply reasonable security measures to protect your data.
      </p>

      <h2>6. Shopify Data</h2>
      <p>
        We only use Shopify data required to operate the app, in compliance with
        Shopify policies.
      </p>

      <h2>7. Contact</h2>
      <p>
        Email: contato@exportadigital.com <br />
        Website: https://intrex.com.br
      </p>
    </div>
  );
};

export default PrivacyPolicy;